import { Bar } from "react-chartjs-2";

import CustomBox from "../../../../../Components/UI/CustomBox/CustomBox/CustomBox";

import "./styles.scss";

const ThreatCategoriesChart = ({ threatCategories, report = false }) => {
  // Chart.js paints the axis labels into a canvas, so css cannot repaint them
  // for the report: the light grey used on the dashboard would be invisible on
  // the pdf's white page.
  const tickColor = report ? "#000000" : "#e0e0e0";

  const categories = threatCategories || [];
  const sorted = [...categories].sort((a, b) => b.count - a.count);
  const topCategories = sorted.slice(0, 10);

  const colorMap = {
    anti_analysis: "rgba(54, 162, 235, 0.8)",
    persistence: "rgba(255, 99, 132, 0.8)",
    fileless: "rgba(255, 206, 86, 0.8)",
    macro_malware: "rgba(75, 192, 192, 0.8)",
    credential_access: "rgba(255, 206, 86, 0.8)",
    ransomware: "rgba(255, 99, 132, 0.8)",
  };

  const getLabel = (cat) => cat.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  const getColor = (cat) => colorMap[cat] || "rgba(54, 162, 235, 0.8)";

  if (topCategories.length === 0) {
    return (
      <CustomBox className="thunter-threat-categories">
        <h2 className="chart-title">Threat Categories</h2>
        <CustomBox className="chart-empty">
          <p>No threat categories data available</p>
        </CustomBox>
      </CustomBox>
    );
  }

  const chartData = {
    labels: topCategories.map((c) => getLabel(c.category)),
    datasets: [
      {
        label: "Instances",
        data: topCategories.map((c) => c.count),
        backgroundColor: topCategories.map((c) => getColor(c.category)),
      },
    ],
  };

  const chartOptions = {
    indexAxis: "x",
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.dataset.label}: ${ctx.raw} instances`,
        },
      },
    },
    responsive: true,
    scales: {
      x: {
        ticks: { color: tickColor, maxRotation: 45, minRotation: 45 },
      },
      y: {
        ticks: { color: tickColor },
      },
    },
  };

  return (
    <CustomBox className="thunter-threat-categories">
      <h2 className="chart-title">Top Threat Categories</h2>

      <div className="thunter-category-tags">
        {topCategories.slice(0, 5).map((item, i) => (
          <span
            key={i}
            className="thunter-tag"
            style={{
              borderColor: getColor(item.category),
              color: getColor(item.category),
            }}>
            {getLabel(item.category)}: {item.count}
          </span>
        ))}
      </div>

      <div className="thunter-threat-bar">
        <Bar data={chartData} options={chartOptions} />
      </div>
    </CustomBox>
  );
};

export default ThreatCategoriesChart;
